<template>
  <ContentWrap>
    <el-alert
      class="owner-filter__tip"
      type="info"
      :closable="false"
      show-icon
      title="这里展示已通过资格的圈主及其名下圈子。待审申请请到「圈子列表 → 圈主审核」。"
    />
    <el-form :model="query" class="owner-filter__form" @submit.prevent>
      <el-form-item label="会员">
        <el-input
          v-model="query.keyword"
          clearable
          class="!w-220px"
          placeholder="昵称/姓名/手机/用户ID"
          @keyup.enter="search"
        />
      </el-form-item>
      <el-form-item class="owner-filter__actions">
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-table v-loading="loading" :data="list">
      <el-table-column prop="id" label="编号" width="90" />
      <el-table-column label="会员资料" min-width="220">
        <template #default="s">
          <div class="flex items-center gap-10px">
            <el-avatar :size="40" :src="s.row.avatar || undefined">
              <Icon icon="ep:user-filled" />
            </el-avatar>
            <div class="min-w-0">
              <div class="font-500 truncate">
                {{ s.row.realName || s.row.nickname || `用户${s.row.userId}` }}
              </div>
              <div class="text-12px text-#909399 truncate">昵称 {{ s.row.nickname || '-' }}</div>
              <div class="text-12px text-#909399">
                {{ s.row.mobile || '无手机号' }} · ID {{ s.row.userId }}
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="公司 / 职位" min-width="180" show-overflow-tooltip>
        <template #default="s">
          <span>{{ [s.row.company, s.row.position].filter(Boolean).join(' · ') || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="名下圈子" min-width="200" show-overflow-tooltip>
        <template #default="s">
          <el-tag v-if="s.row.circleCount" type="success" class="mr-6px">{{ s.row.circleCount }} 个</el-tag>
          <span>{{ s.row.circleNames || '暂无圈子' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="officeAddress" label="办公地址" min-width="160" show-overflow-tooltip />
      <el-table-column prop="tierAmount" label="资格费" width="100" />
      <el-table-column prop="passTime" label="成为圈主" min-width="170" :formatter="dateFormatter" />
    </el-table>
    <Pagination
      v-model:page="query.pageNo"
      v-model:limit="query.pageSize"
      :total="total"
      @pagination="load"
    />
  </ContentWrap>
</template>

<script setup lang="ts">
import { dateFormatter } from '@/utils/formatTime'
import * as OwnerApi from '@/api/business/circleOwner'

defineOptions({ name: 'BossCircleCircleOwner' })

const loading = ref(false)
const list = ref<OwnerApi.CircleOwnerVO[]>([])
const total = ref(0)
const query = reactive({
  pageNo: 1,
  pageSize: 10,
  keyword: ''
})

const load = async () => {
  loading.value = true
  try {
    const params: any = {
      pageNo: query.pageNo,
      pageSize: query.pageSize,
      roster: true
    }
    if (query.keyword?.trim()) params.keyword = query.keyword.trim()
    const d = await OwnerApi.getCircleOwnerPage(params)
    list.value = d.list || []
    total.value = d.total || 0
  } finally {
    loading.value = false
  }
}

const search = () => {
  query.pageNo = 1
  load()
}
const reset = () => {
  query.keyword = ''
  search()
}

onMounted(load)
</script>

<style scoped lang="scss">
.owner-filter__tip {
  display: block;
  margin-bottom: 16px;
}
.owner-filter__form {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px 18px;
}
.owner-filter__form :deep(.el-form-item) {
  margin: 0;
}
.owner-filter__actions :deep(.el-form-item__content) {
  display: flex;
  gap: 8px;
}
.owner-cell {
  display: inline-flex;
  align-items: baseline;
  gap: 8px;
  max-width: 100%;
}
.owner-cell__name {
  color: #303133;
  font-weight: 600;
}
.owner-cell__id {
  color: #909399;
  font-size: 12px;
  white-space: nowrap;
}
</style>
